import { Configuration } from "../api-client";
import { getRegisteredAuthStore } from "./axiosConfig";

/*
  Creates an API Configuration with a function-based accessToken.
  The token is read from the in-memory AuthStore at the time of each API call,
  ensuring the most up-to-date token is used without recreating API clients.
*/
export const createApiConfig = (basePath?: string): Configuration => {
  return new Configuration({
    basePath: basePath || process.env.REACT_APP_API_URL,
    accessToken: () => getRegisteredAuthStore()?.authToken || "",
    baseOptions: {
      withCredentials: true,
    },
  });
};
